<script lang="ts">
  import { toasts, removeToast } from '$lib/stores/toastStore';
</script>

<div class="toast-container position-fixed bottom-0 end-0 p-3">
  {#each $toasts as toast (toast.id)}
    <div
      class="toast align-items-center text-bg-{toast.type} border-0 show"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="d-flex">
        <div class="toast-body">{toast.message}</div>
        <button
          type="button"
          class="btn-close me-2 m-auto"
          aria-label="Close"
          on:click={() => removeToast(toast.id)}
        ></button>
      </div>
    </div>
  {/each}
</div>
